const Landing = () => <div>Landing</div>;

export default Landing;
